import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import React from 'react';
import {
    AuthState,
    GroupInherritablePermission,
    UserInherritablePermission
} from './AppShell/Authentication/AuthorisationModels';
import { Button, ButtonMode } from './Components/Button';
import { ClearIcon, ConfirmedIcon } from './Components/Icons';
import styles from './PermissionControl.module.scss';
import { Nullable } from './Shared/Types';
import { divider, green, red } from './Styles/Colours';

export class PermissionControl extends React.Component<{
    name: string;
    state: AuthState;
    inherited: boolean;
    inherritablePermission: Nullable<UserInherritablePermission | GroupInherritablePermission>;
    onAllowLocal(): void;
    onDenyLocal(): void;
    onInherit(): void;
}> {
    public render() {
        const allowedButtonClasses = classNames(
            styles.buttonAllowed,
            this.props.state === AuthState.Allowed && !this.props.inherited ? styles.isAllow : styles.hasNoDefinition
        );

        const deniedButtonClasses = classNames(
            styles.buttonDenied,
            this.props.state === AuthState.Denied && !this.props.inherited ? styles.isDeny : styles.hasNoDefinition
        );

        const inheritButtonClasses = classNames(styles.buttonInherited, {
            [this.props.inherritablePermission && this.props.inherritablePermission.state === AuthState.Allowed
                ? styles.isAllow
                : styles.isDeny]: this.props.state && this.props.inherited,
            [styles.hasNoDefinition]: !this.props.state && !this.props.inherited
        });

        return (
            <Grid item xs={12} className={styles.permissionControl}>
                <Grid container alignItems='center'>
                    <Grid item xs={4} md={4} lg={3} xl={3}>
                        <h4 className={styles.name}>{this.props.name}</h4>
                    </Grid>
                    <Grid item xs={8} md={8} lg={9}>
                        <Grid container spacing={0} direction='row'>
                            <Grid item>
                                <Button
                                    testId='allow'
                                    className={allowedButtonClasses}
                                    onClick={this.props.onAllowLocal}
                                    mode={ButtonMode.border}
                                    width={112}
                                    startIcon={
                                        <ConfirmedIcon
                                            size='18'
                                            color={
                                                this.props.state === AuthState.Allowed && !this.props.inherited
                                                    ? green
                                                    : divider
                                            }
                                        />
                                    }
                                >
                                    Allow
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    testId='deny'
                                    className={deniedButtonClasses}
                                    onClick={this.props.onDenyLocal}
                                    mode={ButtonMode.border}
                                    width={112}
                                    startIcon={
                                        <ClearIcon
                                            size='18'
                                            color={
                                                this.props.state === AuthState.Denied && !this.props.inherited
                                                    ? red
                                                    : divider
                                            }
                                        />
                                    }
                                >
                                    Deny
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    className={inheritButtonClasses}
                                    testId='inherit'
                                    mode={ButtonMode.text}
                                    onClick={this.props.onInherit}
                                    startIcon={
                                        !this.props.inherritablePermission ? (
                                            <ClearIcon size='18' color={this.props.inherited ? red : divider} />
                                        ) : this.props.inherritablePermission.state === AuthState.Allowed ? (
                                            <ConfirmedIcon size='18' color={this.props.inherited ? green : divider} />
                                        ) : (
                                            <ClearIcon size='18' color={this.props.inherited ? red : divider} />
                                        )
                                    }
                                >
                                    {!this.props.inherritablePermission ? (
                                        <span className={styles.label}>Nothing to inherit from</span>
                                    ) : (
                                        <span className={styles.label}>{this.props.inherritablePermission.name}</span>
                                    )}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}
